
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.86 5.556h2.281l.268-1.07H6.593l.267 1.07z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.531 1.004H.47A.469.469 0 000 1.473v8.066h16V1.473a.469.469 0 00-.469-.47zM6.996 8.25a.469.469 0 110-.938.469.469 0 010 .938zm2.008 0a.469.469 0 110-.938.469.469 0 010 .938zm1.46-4.12L9.96 6.137a.469.469 0 01-.455.356H6.494a.469.469 0 01-.455-.356l-.664-2.657h-.89a.469.469 0 010-.938h1.256c.215 0 .402.147.454.356l.163.649h3.65a.469.469 0 01.455.582zM0 12.016c0 .259.21.469.469.469H15.53c.26 0 .469-.21.469-.469v-1.54H0v1.54zM11.766 14.058H8.469v-.635H7.53v.635H4.234a.469.469 0 100 .938h7.532a.469.469 0 000-.938z","fill":"#fff"}})])
          )
        }
      }
    